import { render, staticRenderFns } from "./Hyjq.vue?vue&type=template&id=9bf19b28&scoped=true"
import script from "./Hyjq.vue?vue&type=script&lang=js"
export * from "./Hyjq.vue?vue&type=script&lang=js"
import style0 from "./Hyjq.vue?vue&type=style&index=0&id=9bf19b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf19b28",
  null
  
)

export default component.exports